export const Colors = {
    bgGray: "#6f7376",
    btnGraySecondary: "#434648",
    
}

export function glassEffect() {
    return localStorage.getItem("use-glass") === "true";
}

export function glassColor(glass = glassEffect(), opacity = 0.6): string {
    return `rgba(111, 115, 118, ${glass ? opacity : 1})`;
}

export function whiteGlassColor(glass = glassEffect(), opacity = 0.6): string {
    return `rgba(255, 255, 255, ${glass ? opacity : 1})`;
}